import React from 'react';

import iconPaths from '../iconPaths.js';

const Icon = ({name}) =>iconPaths[name].svg;
export default Icon;

